module.exports = __webpack_public_path__ + "static/media/locatie.4bcf744e.png";